import { useMediaQuery } from 'react-responsive'

/**
 * Canonical responsive breakpoint hook for desktop layout detection.
 * isDesktop = true when viewport >= 768px (includes tablets).
 *
 * Use this for component-tree switching (JS conditional rendering).
 * For CSS-only responsive changes, use Tailwind's lg: (1024px) prefix instead.
 */
export const useMediaQueryHelper = () => {
  const isDesktop = useMediaQuery({
    query: '(min-width:768px)',
  })

  return {
    isDesktop,
  }
}
